module.exports = __webpack_public_path__ + "media/images/payment-d6958ab2bb712dfd36660719a9edf626.png";